import React, {Component} from 'react';
import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {injectIntl} from 'react-intl';

import {closeSubmitCommentModal} from '../reducers/modals';
import SubmitCommentModalComponent from '../components/menu-bar-assistant/submit-comment.jsx';
import {
    getRemarksList,
    setHomeworkStatus
} from '../lib/service-assistant';
import {setHomeworkCorrected} from '../reducers/assistant';

class SubmitCommentModal extends Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleClickBtnCancel',
            'handleClickBtnConfirm',
            'handleClickBtnIgnore',
            'handleClickCommentlistItem',
            'handleClickGradeLevel',
            'handleClickShowDetail',
            'handleBlurChangeCommentContentText',
            'handleMouseOverGradeStarBlink'
        ]);
        this.state = {
            commentList: [],
            commentListChecked: -1, // -1表示未选择
            itemShowDetail: -1, // -1表示不显示任何一条详情
            gradeLevel: 0,
            gradeStarBlink: 0, // 0表示初始状态，-1表示鼠标移出评分区域
            commentContentText: '',
            commentTipsState: false,
            gradeTipsState: false
        };
    }

    componentDidMount () {
        getRemarksList(this.props.lessonId)
            .then(data => {
                this.setState({
                    commentList: data.map(value => value)
                });
            });
    }

    handleClickBtnCancel () {
        this.props.onCloseProjectSaverInfo();
    }

    handleClickBtnConfirm () {
        if (this.state.commentContentText === '') {
            this.setState({
                commentTipsState: true
            });
        } else if (this.state.gradeStarBlink === 0) {
            this.setState({
                gradeTipsState: true
            });
        } else {
            const remarks = this.state.commentContentText;
            const score = this.state.gradeLevel;
            const correctStatus = 'DONE';
            const id = this.props.homeworkId;
            setHomeworkStatus(correctStatus, id, remarks, score);
            this.props.onSetHomeworkCorrected();
            this.props.onCloseProjectSaverInfo();
        }
    }

    handleClickBtnIgnore () {
        const correctStatus = 'IGNORE';
        const id = this.props.homeworkId;
        setHomeworkStatus(correctStatus, id, null, null);
        this.props.onSetHomeworkCorrected();
        this.props.onCloseProjectSaverInfo();
    }

    handleClickCommentlistItem (event) {
        const key = ~~event.currentTarget.getAttribute('data-key');
        const commentDom = document.getElementById('comment-content-textarea');
        commentDom.value = this.state.commentList[key].content;
        this.setState({
            commentListChecked: key,
            commentContentText: this.state.commentList[key].content.trim(),
            commentTipsState: this.state.commentList[key].content === ''
        });
    }

    handleClickGradeLevel (event) {
        const level = ~~event.currentTarget.getAttribute('data-level');
        this.setState({
            gradeLevel: level,
            gradeTipsState: level === 0
        });
    }

    handleBlurChangeCommentContentText () {
        const commentValue = document.getElementById('comment-content-textarea').value.trim();
        this.setState({
            commentContentText: commentValue,
            commentTipsState: commentValue === ''
        });
    }

    handleClickShowDetail (event) {
        const key = ~~event.currentTarget.getAttribute('data-key');
        if (this.state.itemShowDetail === key) {
            this.setState({
                itemShowDetail: -1
            });
        } else {
            this.setState({
                itemShowDetail: key
            });
        }
    }

    handleMouseOverGradeStarBlink (event) {
        const level = ~~event.currentTarget.getAttribute('data-level');
        let gradeStarBlink;
        if (level === -1) {
            gradeStarBlink = this.state.gradeLevel;
        } else {
            gradeStarBlink = level;
        }

        this.setState({
            gradeStarBlink
        });
    }

    render () {
        return (
            <SubmitCommentModalComponent
                commentList={this.state.commentList}
                commentListChecked={this.state.commentListChecked}
                commentTipsState={this.state.commentTipsState}
                gradeStarBlink={this.state.gradeStarBlink}
                gradeTipsState={this.state.gradeTipsState}
                isTutor={this.props.isTutor}
                itemShowDetail={this.state.itemShowDetail}
                onClickBtnCancel={this.handleClickBtnCancel}
                onClickBtnConfirm={this.handleClickBtnConfirm}
                onClickBtnIgnore={this.handleClickBtnIgnore}
                onClickCommentlistItem={this.handleClickCommentlistItem}
                onClickGradeLevel={this.handleClickGradeLevel}
                onClickShowDetail={this.handleClickShowDetail}
                onCloseRequest={this.props.onCloseProjectSaverInfo}
                onCommentContentBlur={this.handleBlurChangeCommentContentText}
                onMouseOverGradeStarBlink={this.handleMouseOverGradeStarBlink}
            />
        );
    }
}

SubmitCommentModal.propTypes = {
    homeworkId: PropTypes.number,
    isTutor: PropTypes.bool,
    lessonId: PropTypes.number,
    onCloseProjectSaverInfo: PropTypes.func.isRequired,
    onSetHomeworkCorrected: PropTypes.func.isRequired
};

const mapDispatchToProps = dispatch => ({
    onCloseProjectSaverInfo: () => dispatch(closeSubmitCommentModal()),
    onSetHomeworkCorrected: () => dispatch(setHomeworkCorrected())
});

export default injectIntl(connect(
    null,
    mapDispatchToProps
)(SubmitCommentModal));
